"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const shared_types_1 = require("../../shared-types");
exports.requestSchema = zod_1.z.object({
    hashCode: zod_1.z.string(),
    password: zod_1.z.string(),
    appMeta: shared_types_1.appMetaSchema.optional(),
});
exports.path = '/choose-password';
//# sourceMappingURL=index.js.map